// extracted by mini-css-extract-plugin
export default {"page":"styles_page__tpjz-","leftPanel":"styles_leftPanel__DLxTv","rightPanel":"styles_rightPanel__XdlRE","form":"styles_form__OW86Z","footerError":"styles_footerError__PLOGB"};